import makePageFormModel from './makePageFormModel.vue';
import cookieFormModel from './cookieFormModel.vue';
import { systemConfigResourse } from '../request';
export default {
  components: {
    makePageFormModel,
    cookieFormModel
  },
  data() {
    return {
      activeKey: '3',
      //3、使用协议 4、隐私政策 5、cookie管理
      tabs: [{
        tab: '使用协议',
        key: '3',
        auth: 'home.serviceContract'
      }, {
        tab: '隐私政策',
        key: '4',
        auth: 'home.privacyPolicy'
      }, {
        tab: 'cookie管理',
        key: '5',
        auth: 'home.cookieManage'
      }],
      collapses: [{
        title: '简体中文',
        key: 'zh'
      }, {
        title: '繁体中文',
        key: 'cht'
      }, {
        title: '英语',
        key: 'en'
      }, {
        title: '法语',
        key: 'fra'
      }, {
        title: '西班牙语',
        key: 'spa'
      }],
      datas: {}
    };
  },
  mounted() {
    // 权限获取
    if (this.isAuth('home.serviceContract')) {
      this.activeKey = '3';
    } else if (this.isAuth('home.privacyPolicy')) {
      this.activeKey = '4';
    } else if (this.isAuth('home.cookieManage')) {
      this.activeKey = '5';
    }
    this.getSystemConfig();
  },
  methods: {
    tabsChange(key) {
      this.activeKey = key;
      this.getSystemConfig();
    },
    async getSystemConfig() {
      let res = await systemConfigResourse({
        type: this.activeKey
      });
      this.datas = res;
    }
  }
};